import closeIco from '@assets/generalItems/deleteCrossGray.png'
import icoCenter from '@assets/nuevos-iconos/iconoCentrar.png'
import { useHoleModal } from '@components/HolesModal/useHoleModal'
import * as Dialog from '@radix-ui/react-dialog'
import * as Form from '@radix-ui/react-form'
import { useAppStore } from '@store'
import { Item, Store } from '@types'
import isPartition from '@utils/sceneObjects/assertions/isPartition'
import getId from '@utils/sceneObjects/getId'
import { ChangeEvent, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

type Props = { msg: string }
export default function DoorModal({ msg }: Props) {
  const { id: _id } = useParams()

  const [id, wallId] = _id.split('.')
  const currItem = useAppStore.use.currentObjectID()
  const item = useAppStore.use.items().get(currItem) as Item
  const select = useAppStore.use.select()
  const unselect = useAppStore.use.unselectAll()
  // TODO refactor to use find so it doesn't depend on order
  let itemWidth = item?.morphs?.[0]?.default
  let itemHeight = item?.morphs?.[1]?.default
  let itemHighness = item?.morphs?.[2]?.default
  if (item?.morphs) {
    if (item.morphs?.[0]?.max) {
      itemWidth > item.morphs?.[0].max ? (itemWidth = item.morphs?.[0].max) : ''
    }
    if (item.morphs?.[0]?.min) {
      itemWidth < item.morphs?.[0].min ? (itemWidth = item.morphs?.[0].min) : ''
    }
    if (item.morphs?.[1]?.max) {
      itemHeight > item.morphs?.[1].max ? (itemHeight = item.morphs?.[1].max) : ''
    }
    if (item.morphs?.[1]?.min) {
      itemHeight < item.morphs?.[1].min ? (itemHeight = item.morphs?.[1].min) : ''
    }
    if (item.morphs?.[2]?.max) {
      itemHighness > item.morphs?.[2].max ? (itemHighness = item.morphs?.[2].max) : ''
    }
    if (item.morphs?.[2].min) {
      itemHighness < item.morphs?.[2].min ? (itemHighness = item.morphs?.[2].min) : ''
    }
  }
  const numWallWidth = useAppStore((store) => store.items.get(wallId)?.width) ?? 0
  const wallThickness = useAppStore((store) => store.items.get(wallId)?.thickness)
  const setMode = useAppStore.use.setMode()
  const deleteSceneObject = useAppStore.use.deleteSceneObject()
  const setCurrentObjectID = useAppStore.use.setCurrentObjectID()
  const addHole = useAppStore.use.addHole()
  const editHole = useAppStore.use.editHole()
  const drawHole = useAppStore.use.drawHole()
  const { bisagras, manos, combinaciones } = useHoleModal(id)
  const img = useAppStore((s) => s.items.get(s.currentObjectID)?.image)
  const updateHole = useAppStore.use.updateHole()
  const editHolePosition = useAppStore.use.editHolePosition()
  const editHolePositionIfPartition = useAppStore.use.editHolePositionIfPartition()
  const editMorph = useAppStore.use.editMorph()
  const closeModal = useAppStore.use.closeModal()

  useEffect(() => {
    setSizes({
      distD: numWallWidth - itemWidth,
      distI: 0,
      width: itemWidth,
      height: itemHighness,
      floorHeight: item?.y ?? 0,
      mano: manos,
      bisagra: bisagras,
    })
  }, [bisagras, manos, combinaciones, numWallWidth, itemWidth, itemHeight, item?.y])
  const [{ distD, distI, width, height, floorHeight, mano, bisagra }, setSizes] = useState(() => ({
    distD: 0,
    distI: 0,
    width: 0,
    height: 0,
    floorHeight: 0,
    mano: null,
    bisagra: null,
  }))

  // TODO: esto no se usa? revisar
  const [sumResult, setSumResult] = useState<number | null>(null)
  const [calculateOnButtonClick, setCalculateOnButtonClick] = useState(false)

  function calculateSumAndDivide() {
    if (distD !== null && distI !== null) {
      const sum = distD + distI
      let divisionResult = Math.floor(sum / 2)
      const remainder = sum % 2
      if (remainder !== 0) {
        const adjustment = remainder / 2
        divisionResult += adjustment
      }
      setSizes((prev) => ({
        ...prev,
        distI: divisionResult + remainder,
        distD: divisionResult,
      }))
      setSumResult(divisionResult)
    }
  }

  useEffect(() => {
    if (calculateOnButtonClick) {
      calculateSumAndDivide()
    }
  }, [calculateOnButtonClick])

  function handleCalculateButtonClick(e) {
    e.preventDefault()
    setCalculateOnButtonClick(true)
  }

  function handleNumberChange(e: ChangeEvent<HTMLInputElement>, isSpecial = false) {
    const value = parseFloat(e.target.value)
    if (e.target.value === '0' || e.target.value === '' || isNaN(value)) {
      if (!width && width !== 0) return
      switch (e.target.name) {
        case 'distI': {
          setSizes((prev) => ({ ...prev, distI: 0, distD: numWallWidth - width }))
          return
        }
        case 'distD': {
          setSizes((prev) => ({ ...prev, distI: numWallWidth - width, distD: 0 }))
          return
        }
        case 'width': {
          setSizes((prev) => ({
            ...prev,
            width: item.morphs[0]?.min,
            distD: distI + item.morphs[0]?.min,
          }))
          return
        }
        default:
          setSizes((prev) => ({ ...prev, [e.target.name]: 0 }))
          return
      }
    }
    switch (e.target.name) {
      case 'distI':
        // S|---\---Item-\------|E
        // Cases: distI+itemWidth > wallSize
        if (value >= numWallWidth - width) {
          setSizes((prev) => ({
            ...prev,
            distI: numWallWidth - width,
            distD: 0,
          }))
        } else {
          setSizes((prev) => ({
            ...prev,
            distI: value,
            distD: numWallWidth - value - width,
          }))
        }
        break
      case 'distD':
        // S|---\---Item-\------|E
        // Cases: distD-itemWidth <0
        if (value + width > numWallWidth) {
          if (width >= numWallWidth) {
            setSizes((prev) => ({ ...prev, distD: 0 }))
            break
          }
          setSizes((prev) => ({
            ...prev,
            distI: 0,
            distD: numWallWidth - itemWidth,
          }))
        } else {
          setSizes((prev) => ({
            ...prev,
            distI: numWallWidth - value - width,
            distD: value,
          }))
        }
        break
      case 'width':
        if (value > numWallWidth) {
          setSizes((prev) => ({ ...prev, width: numWallWidth, distI: 0, distD: 0 }))
          break
        }
        setSizes((prev) => ({ ...prev, width: value, distD: numWallWidth - value - distI }))
        break
      default:
        setSizes((prev) => ({ ...prev, [e.target.name]: parseFloat(e.target.value) }))
        break
    }
  }
  function handleCheckboxChange(e) {
    setSizes((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }
  function handleSubmit(e) {
    e.preventDefault()
    const finalID = combinaciones?.find(
      (el: { mano: string; bisagra: string; idUnidades: number }) =>
        el?.mano === mano && el?.bisagra === bisagra,
    )
    const newHoleID = getId('holes')
    drawHole(newHoleID, finalID?.idUnidades ?? id, { mano, bisagra }, img)
    addHole(wallId, newHoleID)
    setTimeout(() => {
      if (isPartition(wallId)) {
        editHolePositionIfPartition(
          newHoleID,
          wallId,
          distI,
          distD,
          finalID.bisagra,
          finalID.mano,
          finalID.bisagra,
        )
      } else {
        editHolePosition(
          newHoleID,
          wallId,
          distI,
          distD,
          finalID.bisagra,
          finalID.mano,
          finalID.bisagra,
        )
      }
      editMorph(newHoleID, 'Fondo', wallThickness)
      const maxW = item.morphs[0]?.max
      const minW = item.morphs[0]?.min
      const newHoleWidth = width > maxW ? maxW : width < minW ? minW : width
      editHole(newHoleID, { width: newHoleWidth })
      editMorph(newHoleID, 'Ancho', newHoleWidth)
      editMorph(newHoleID, 'Alto', height)
      editHole(newHoleID, { y: floorHeight })
      setMode('MODE_IDLE')
      deleteSceneObject(item.id)
      setCurrentObjectID('')
      updateHole(newHoleID)
      closeModal()
      unselect()
      setTimeout(() => {
        select(newHoleID)
      }, 500)
      navigate(-1)
    }, 1000)
  }
  function cancelSubmit(e) {
    e.preventDefault()
    setMode('MODE_IDLE')
    deleteSceneObject(id)
    setCurrentObjectID('')
    closeModal()
    navigate(-1)
  }

  const navigate = useNavigate()
  const fieldStyles = 'p-2 mx-[120px]'
  const labelStyles = ' self-left text-left text-C/Color5 '
  const inputStyles =
    ' text-right rounded border border-solid p-1.5 max-w-[100px] self-right border-C/Color4'
  const baseDivStyle = 'min-w-[150px] inline-block'
  const outerDiv = 'rounded-lg bg-C/Color10 px-6 py-2 shadow-md mb-4 text-C/Color5'
  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Overlay className='white-background absolute inset-0 content-center overflow-hidden rounded-s '>
          <Dialog.Content className='absolute left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-2xl border-2 border-C/Color3 bg-C/Color1 text-left text-xs shadow-xl'>
            <Dialog.Title className='sr-only'>{'Medidas puerta'}</Dialog.Title>
            <Dialog.Description className='sr-only'>{'Tipo puerta'}</Dialog.Description>
            <div className='relative ml-0 mt-0 rounded-t-xl border border-C/Color3'>
              <Dialog.Close
                onClick={(e) => {
                  closeModal()
                  cancelSubmit(e)
                }}
                className='absolute right-3 top-2 z-[100] mb-2 cursor-pointer'
              >
                <img
                  className=''
                  src={closeIco}
                  alt='icon close'
                />
              </Dialog.Close>
              <section className='h-6 rounded-t-md bg-C/Color3 pl-2 text-sm font-semibold text-C/Color1'>
                {msg}
              </section>
            </div>
            <Form.Root className='flex-cols mx-4'>
              <div className='align-center mb-14 mt-5 grid grid-cols-1'>
                <div className={`${outerDiv}`}>
                  <span className='font-bold'>{'Medidas puerta'} </span>
                  <Form.Field
                    className={`${fieldStyles} `}
                    name='width'
                  >
                    <div className={`${baseDivStyle}`}>
                      <Form.Label className={`${labelStyles}`}>{'Ancho'}</Form.Label>
                    </div>
                    <Form.Control
                      className={`${inputStyles}`}
                      onChange={handleNumberChange}
                      value={width ?? 0}
                      type='number'
                    />
                  </Form.Field>
                  <Form.Field
                    className={`${fieldStyles}`}
                    name='height'
                  >
                    <div className={`${baseDivStyle}`}>
                      <Form.Label className={`${labelStyles}`}>{'Altura'}</Form.Label>
                    </div>
                    <Form.Control
                      className={`${inputStyles}`}
                      onChange={handleNumberChange}
                      value={height ?? 0}
                      type='number'
                    />
                  </Form.Field>
                </div>
                <div className={`${outerDiv}`}>
                  <span className='font-bold'>{'Posicionamiento'}</span>
                  <Form.Field
                    className={`${fieldStyles}`}
                    name='distI'
                  >
                    <img
                      src={icoCenter}
                      alt='icon center'
                      className='absolute ml-[274px] mt-4 h-6 cursor-pointer'
                      onClick={handleCalculateButtonClick}
                    />
                    <p className='absolute ml-[310px] mt-5'>{'Centrar'}</p>
                    <div className={`${baseDivStyle}`}>
                      <Form.Label className={`${labelStyles}`}>{'Distancia Izquierda'}</Form.Label>
                    </div>
                    <Form.Control
                      className={`${inputStyles}`}
                      onChange={handleNumberChange}
                      value={Math.floor(distI) ?? 0}
                      type='number'
                    />
                  </Form.Field>
                  <Form.Field
                    className={`${fieldStyles}`}
                    name='distD'
                  >
                    <div className={`${baseDivStyle}`}>
                      <Form.Label className={`${labelStyles}`}>{'Distancia Derecha'}</Form.Label>
                    </div>
                    <Form.Control
                      className={`${inputStyles}`}
                      onChange={handleNumberChange}
                      // onAbort={handleNumberChange}
                      value={Math.floor(distD) ?? 0}
                      type='number'
                    />
                  </Form.Field>
                  <Form.Field
                    className={`${fieldStyles}`}
                    name='floorHeight'
                  >
                    <div className={`${baseDivStyle}`}>
                      <Form.Label className={`${labelStyles}`}>
                        {'Altura desde el suelo'}
                      </Form.Label>
                    </div>
                    <Form.Control
                      className={`${inputStyles}`}
                      onChange={handleNumberChange}
                      value={floorHeight ?? 0}
                      type='number'
                    />
                  </Form.Field>
                </div>
                <div className={`${outerDiv}`}>
                  <span className='font-bold'>{'Tipo puerta'} </span>
                  {manos && manos?.length >= 1 && (
                    <Form.Field
                      name='manos'
                      className={`${fieldStyles} grid grid-cols-3 items-center justify-items-center align-middle `}
                    >
                      <Form.Label>{'Mano'} </Form.Label>
                      <div className='flex items-center'>
                        <input
                          type='radio'
                          className='radio-tpc'
                          name='mano'
                          value='Izquierda'
                          tabIndex={1}
                          onClick={handleCheckboxChange}
                          onChange={handleCheckboxChange}
                          checked={mano === 'Izquierda' || (!mano && mano !== 'Derecha')}
                        />
                        <label className='ml-1 text-center'>{'Izquierda'}</label>
                      </div>
                      <div className='flex items-center'>
                        <input
                          type='radio'
                          className='radio-tpc self-right'
                          name='mano'
                          value='Derecha'
                          tabIndex={2}
                          onClick={handleCheckboxChange}
                          onChange={handleCheckboxChange}
                          checked={mano === 'Derecha'}
                        />
                        <label className='ml-1 text-center'>{'Derecha'} </label>
                      </div>
                    </Form.Field>
                  )}
                  {bisagras && bisagras?.length >= 1 && (
                    <Form.Field
                      name='bisagra'
                      className={`${fieldStyles}  grid grid-cols-3 items-center justify-items-center align-middle`}
                    >
                      <Form.Label>{'Bisagras'}</Form.Label>
                      <div className='flex items-center'>
                        <input
                          type='radio'
                          className='radio-tpc'
                          name='bisagra'
                          value='Interior'
                          onClick={handleCheckboxChange}
                          checked={bisagra === 'Interior' || (!bisagra && bisagra === 'Exterior')}
                        />
                        <label className='ml-1 text-center'>{'Interior'}</label>
                      </div>
                      <div className='flex items-center'>
                        <input
                          type='radio'
                          className='radio-tpc'
                          name='bisagra'
                          value='Exterior'
                          onClick={handleCheckboxChange}
                          checked={bisagra === 'Exterior'}
                        />
                        <label className='ml-1 text-center'>{'Exterior'}</label>
                      </div>
                    </Form.Field>
                  )}
                </div>
              </div>
              <div className='absolute bottom-3 right-10 '>
                <Form.Submit
                  className='mr-2 rounded-md border border-solid border-C/Color7 bg-C/Color3 px-5 py-1 text-C/Color7'
                  onClick={handleSubmit}
                >
                  {msg}
                </Form.Submit>
                <Form.Submit
                  className='mr-2 rounded-md border-2 border-r-2 border-C/Color3 bg-C/Color7 px-5 py-1 text-C/Color3'
                  onClick={cancelSubmit}
                >
                  {'Cancelar'}
                </Form.Submit>
              </div>
            </Form.Root>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
